export const PROMPT_OUTPUT_VARIABLE_PREFIX = 'OUTPUT_';
export const PROMPT_USER_INPUT_VARIABLE_PREFIX = 'CHOICE_';
